<div ngModelGroup="panelGrp_{{panelId}}">
    @if (!noWrap) {
    <div>
        @if (doneLoading) {
        <div>
            @for (row of rowArray; track trackByRow($index, row)) {
            <div [hidden]="!doneLoading" class="layout-row layout-align-start-start"
                [ngClass]="{'dense-input': dense, 'metadata-panel-row': !isMenu}">
                @for (metadataIntermediary of getPropertiesForRow(row); track trackByProperty($index,
                metadataIntermediary)) {
                <div [hidden]="IsHidden(metadataIntermediary)"
                    class="edit-field flex-{{DrawWidth(metadataIntermediary)}}"
                    [ngClass]="{'tt-padding-bottom-sm': !compactMode}">
                    <metadata-input [viewOnly]="viewOnly" [dense]="dense" [field]="metadataIntermediary.name"
                        [metadata]="metadataIntermediary.metadata" [metadataModel]="metadataIntermediary.model"
                        [parent]="metadataIntermediary.parent" [compact]="compactMode"
                        [ngClass]="{'compact-mode': compactMode}" (modifierCallback)="doMetadataModifier($event)"
                        [datacontroller]="datacontroller" [index]="index" [isMenu]="isMenu" [onPanelGrid]="onPanelGrid">
                    </metadata-input>
                </div>
                }
            </div>
            }
        </div>
        }
    </div>
    }

    @if (noWrap) {
    <div class="layout-row">
        @if (doneLoading) {
        <div>
            @for (metadataIntermediary of properties; track metadataIntermediary) {
            <div [ngStyle]="getWidthStyle(metadataIntermediary)" [hidden]="IsHidden(metadataIntermediary)"
                class="edit-field">
                <metadata-input [viewOnly]="viewOnly" [dense]="dense" [field]="metadataIntermediary.name"
                    [metadata]="metadataIntermediary.metadata" [metadataModel]="metadataIntermediary.model"
                    [parent]="metadataIntermediary.parent" [compact]="compactMode"
                    [ngClass]="{'compact-mode': compactMode}" (modifierCallback)="doMetadataModifier($event)"
                    (onUpdateForm)="updateForm($event)" [datacontroller]="datacontroller" [index]="index"
                    [onPanelGrid]="onPanelGrid">
                </metadata-input>
            </div>
            }
        </div>
        }
    </div>
    }
</div>